import { useBoUsers } from '@gozoki/api'
import { includesLowerCase } from '@gozoki/tools'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo, useState } from 'react'
import { RbacAccessDenied } from '~/components/routes/administration/roles/access-denied'
import { useToast } from '~/components/communication/Toast'
import { USERS_TAB_PERMISSIONS } from '~/components/routes/users/tabs'
import { boUsersColumns } from '~/components/routes/users/users-columns'
import { UsersHeaderActions } from '~/components/routes/users/users-header-actions'
import { UsersPageLayout, UsersSearchGrid } from '~/components/routes/users/users-page-layout'
import { useDeleteAdmin } from '~/components/routes/users/use-delete-selection'
import { useMigratedRight, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/users/bo')({
  staticData: {
    permission: USERS_TAB_PERMISSIONS.bo,
  },
  component: BoUsersPage,
})
withRoutePermissions(Route)

function BoUsersPage() {
  const canRead = useMigratedRight(USERS_TAB_PERMISSIONS.bo, ['SUPER_ADMIN'])

  const [Toast, showToast] = useToast()
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState<number[]>([])

  const { data: boUsers, refetch, isLoading } = useBoUsers()

  const users = useMemo(() => boUsers ?? [], [boUsers])

  const rows = useMemo(
    () =>
      users.filter((user) =>
        includesLowerCase(`${user.firstName} ${user.lastName} ${user.email}`, search),
      ),
    [users, search],
  )

  const handleDelete = useDeleteAdmin(selected, showToast, () => {
    setSelected([])
    return refetch()
  })

  // L'onglet interdit est désactivé, mais la route reste une URL atteignable directement.
  if (!canRead) {
    return <RbacAccessDenied />
  }

  return (
    <UsersPageLayout
      activeTab="bo"
      actions={
        <UsersHeaderActions activeTab="bo" selected={selected} handleDelete={handleDelete} />
      }
    >
      <Toast />
      <UsersSearchGrid
        search={search}
        onSearchChange={setSearch}
        columns={boUsersColumns}
        rows={rows}
        loading={isLoading}
        onRowSelectionModelChange={setSelected}
      />
    </UsersPageLayout>
  )
}
